import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'

// Fuentes de Florece
const link = document.createElement('link')
link.rel = 'stylesheet'
link.href = 'https://fonts.googleapis.com/css2?family=Cormorant+Garamond:ital,wght@0,300;0,400;0,600;1,400&family=DM+Sans:wght@300;400;500;600&family=Lora:ital@1&display=swap'
document.head.appendChild(link)

// Reset básico
const style = document.createElement('style')
style.textContent = '* { margin:0; padding:0; box-sizing:border-box; } body { background:#FAF6EE; }'
document.head.appendChild(style)

const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(<React.StrictMode><App /></React.StrictMode>)
